import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ProperPageResult } from 'src/app/model/proper-page-result';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { BoardTypeSearchParameter } from '../input/helper/board-type-search-parameter';
import { SearchSubProjectsInput } from '../input/helper/search-subprojects-input';
import { SubProjectTypeSearchParameter } from '../input/helper/sub-project-type-search-parameter';
import { SearchSubProject } from './model/search-sub-project';
import { Observable } from 'rxjs';
import { _post } from '../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class SearchSubProjectsControllerRequestService {
  private static BASE_URL = '/subprojects/searchPage';
  private readonly post: <T>(
    path: string,
    body: RequestBody,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserializePaged = (res) => {
    const result: ProperPageResult<SearchSubProject> = new ProperPageResult();
    result.totalItems = res.totalItems;
    result.items = res.items;
    return result;
  };

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      SearchSubProjectsControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public searchSubProjects(
    searchInput: SearchSubProjectsInput,
    sort: string,
    sortAscending: boolean,
    pageSize: number,
    page: number
  ): Promise<ProperPageResult<SearchSubProject>> {
    const requestBody: RequestBody = {
      projectId: searchInput.projectId,
      companyId: searchInput.company == null ? null : searchInput.company.id,
      contactId: searchInput.contact == null ? null : searchInput.contact.id,
      street: searchInput.street,
      number: searchInput.number,
      city: searchInput.city,
      postalCode: searchInput.postalCode,
      subProjectTypes: searchInput.subProjectTypes,
      boardTypeSearchParameters: searchInput.boardTypeSearchParameters,
      noCompletedRepo: searchInput.noCompletedRepo,
      pending: searchInput.pending,
    };
    const pageableParam: string = `page=${page}&size=${pageSize}&sortDirection=${
      sortAscending ? 'ASC' : 'DESC'
    }&sortProperty=${sort}`;

    return this.post(
      `?${pageableParam}`,
      requestBody,
      this.deserializePaged
    ).toPromise();
  }
}

interface RequestBody {
  projectId?: number;

  companyId?: number;

  contactId?: number;

  street?: string;

  number?: string;

  city?: string;

  postalCode?: string;

  subProjectTypes?: SubProjectTypeSearchParameter[];

  boardTypeSearchParameters?: BoardTypeSearchParameter[];

  noCompletedRepo: boolean;

  pending: boolean;
}
